import { render, staticRenderFns } from "./MarketViewLiveDetailV5Terminal.vue?vue&type=template&id=ab048468&scoped=true"
import script from "./MarketViewLiveDetailV5Terminal.vue?vue&type=script&lang=js"
export * from "./MarketViewLiveDetailV5Terminal.vue?vue&type=script&lang=js"
import style0 from "./MarketViewLiveDetailV5Terminal.vue?vue&type=style&index=0&id=ab048468&prod&scoped=true&lang=css"
import style1 from "./MarketViewLiveDetailV5Terminal.vue?vue&type=style&index=1&id=ab048468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab048468",
  null
  
)

export default component.exports